import React from 'react';
import * as Styles from 'pages/member/wh/WH.style';
import { useTranslation } from 'react-i18next';
import WHSize from 'components/wh/create/WHSize';
import { get } from 'lodash';
import FormikErrorMessage from 'components/formik-error-message';
import Heading from 'components/Heading/Heading';
import { NewStepDescription } from 'assets/css/common-styles';
import { P } from 'components/reusable-css';

const WHStep2 = ({ whSizesData, whSizesPricesData, handleSizeSelection, selectedSize, formikProp }) => {
  const { t } = useTranslation();
  return (
    <Styles.WHStep2SC id="ST2">
      <Heading name={'wh/create.step2_string1'}>
        <NewStepDescription />
        <Styles.Margin>
          <P>{t('wh/create.step2_string2')}</P>
          <Styles.InlineSizesContainer>
            {get(whSizesData, 'data', [])
              .filter((i) => i.active)
              .map((size, i) => {
                const sizePrice = whSizesPricesData?.prices_wh_sizes?.find((data) => size.id === data.id);
                return (
                  <WHSize
                    selected={size?.id === selectedSize?.id}
                    index={i}
                    length={whSizesData.data.length}
                    onClick={handleSizeSelection}
                    size={size}
                    key={size?.id}
                    sizePrice={sizePrice}
                  />
                );
              })}
          </Styles.InlineSizesContainer>
        </Styles.Margin>
        <FormikErrorMessage formikProp={formikProp} value="size" />
      </Heading>
    </Styles.WHStep2SC>
  );
};
export default WHStep2;
